import { useLanguage } from '@/src/contexts';
import { getText, TranslationKey } from '@/src/helpers';
import { TableHead, TableRow } from '@/src/ui-components';

export function OpenOrdersHeaders() {
  const { language } = useLanguage();

  const getTranslation = (key: TranslationKey) => getText(language, key);

  return (
    <TableRow>
      <TableHead>{getTranslation('side')}</TableHead>
      <TableHead>{getTranslation('price')}</TableHead>
      <TableHead>{getTranslation('amount')}</TableHead>
      <TableHead>{getTranslation('total')}</TableHead>
      <TableHead>{getTranslation('offerSequence')}</TableHead>
      <TableHead className="text-center">{getTranslation('action')}</TableHead>
    </TableRow>
  );
}
